import { Component, h } from 'preact'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import ButtonControl from '../button-control/index'
import BadgeSelector from '../badges/BadgeSelector'
import axios from 'axios'
import tracker from '../../components/tracker/publish'
import { Badge, BadgeList} from "./index";

interface Props {
  userId: number,
  userName: string,
  userRole: string,
  revokerId: number,
  revokerUsername: string,
  revokerRole: string
}

interface State {
  badgesList: BadgeList | null,
  selectedBadge: string | null,
  isModalOpen: boolean,
  error?: string
}

class RevokeBadgeModal extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      badgesList: null,
      selectedBadge: null,
      isModalOpen: true
    }
    this.revokeBadge = this.revokeBadge.bind(this)
    this.onBadgeSelected = this.onBadgeSelected.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.trackBadgeAwardedEvent = this.trackBadgeAwardedEvent.bind(this)
  }

  async componentDidMount () {
    const response = await axios.get(`/settings/badge/getBadgesList?userid=${this.props.userId}`)
    this.setState({ badgesList: response.data })
  }

  async revokeBadge () {
    const { selectedBadge } = this.state
    const userId = this.props.userId

    if (!selectedBadge) {
      this.setState({error: 'Please select a badge'})
      return
    }

    try {
      await axios.post('/settings/badge/revoke', {
        badgeId: selectedBadge,
        userId: userId
      }).then(() => {
        this.trackBadgeAwardedEvent(selectedBadge)
        this.closeModal()
        window.location.reload()

      })
    } catch (e) {}
  }

  trackBadgeAwardedEvent (selectedBadge: string) {
    const { badgesList } = this.state
    const { revokerId, revokerUsername, revokerRole, userId, userName, userRole } = this.props

    if (!badgesList) return

    const revokedBadge = badgesList.find((badge) => badge.id.toString() === selectedBadge)

    if (!revokedBadge) return

    tracker.trackEvent('userevent', {
      type: 'Badge Revoked',
      badgeId: revokedBadge.id,
      badgeName: revokedBadge.title,
      badgeDescription: revokedBadge.description,
      revokerId: revokerId,
      revokerUsername: revokerUsername,
      revokerRole: revokerRole,
      revokedId: userId,
      revokedUsername: userName,
      revokedRole: userRole
    })
  }

  getSelectedBadge (): Badge | undefined {
    const { badgesList, selectedBadge } = this.state
    if (!badgesList) return
    return badgesList.find((badge) => badge.id.toString() === selectedBadge)
  }

  onBadgeSelected (badgeId: string) {
    this.setState({ selectedBadge: badgeId, error: undefined })
  }

  closeModal () {
    this.setState({ isModalOpen: false })
  }

  render (props: Props, state: State) {
    if (!state.badgesList) return null

    return (
      <Modal isOpen={state.isModalOpen}>
        <ModalHeader title='Revoke badge' onClose={() => this.closeModal()} />
        <ModalBody>
          <BadgeSelector
            badges={state.badgesList}
            selected={this.getSelectedBadge()}
            onChange={this.onBadgeSelected}
            error={state.error}
          />
        </ModalBody>
        <ModalFooter>
          <ButtonControl title='Revoke' variant='primary' onClick={() => this.revokeBadge()} />
          <ButtonControl title='Cancel' onClick={() => this.closeModal()} />
        </ModalFooter>
      </Modal>
    )
  }
}

export default RevokeBadgeModal
